import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import ar from "./locales/ar.json";

const LANGUAGE_STORAGE_KEY = "app_language";

i18n.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources: {
			en: { translation: en },
			ar: { translation: ar },
		},
		fallbackLng: "en",
		supportedLngs: ["en", "ar"],
		detection: {
			order: ["localStorage", "navigator"],
			caches: ["localStorage"],
			lookupLocalStorage: LANGUAGE_STORAGE_KEY,
		},
		interpolation: {
			escapeValue: false,
		},
	});

export { LANGUAGE_STORAGE_KEY };
export default i18n;
